import { GetterTree } from 'vuex';
import { StateInterface } from '../index';
import { UserStateInterface } from './state';

const getters: GetterTree<UserStateInterface, StateInterface> = {
  hasPermission: (state: UserStateInterface) => (permission: string) => {
    return state.permissions.some(x => x === permission);
  }
};

export default getters;
